module.exports = __webpack_public_path__ + "static/media/clearbit-scrn.bd7eab07.jpg";